import { apiRequest, HttpMethod } from '@hqo/shared-modules/dist/api-request';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { SubdomainsResponse, TenantPortalFieldsEnum } from 'app/data/types/subdomains';
import { useApi } from 'app/shared/contexts/api';
import { useBuilding } from 'app/shared/contexts/building';
import qs from 'qs';

export const getGetSubdomainsQueryKey = (buildingUuid: string): QueryKey => ['subdomains', buildingUuid];

export const useGetSubdomainsQuery = () => {
  const { building } = useBuilding();
  const buildingUuid = building?.uuid ?? '';
  const { apiUrl, getAuthHeaders } = useApi();

  return useQuery<SubdomainsResponse>({
    queryKey: getGetSubdomainsQueryKey(buildingUuid),
    queryFn: async (): Promise<SubdomainsResponse> => {
      const headers = await getAuthHeaders();
      const queryString = qs.stringify({
        fields: [TenantPortalFieldsEnum.SUBDOMAIN, TenantPortalFieldsEnum.UUID, TenantPortalFieldsEnum.ENABLED],
      });

      const response = await apiRequest<SubdomainsResponse, void, void>({
        url: `${apiUrl}/api/buildings/${buildingUuid}/tenant-portals?${queryString}`,
        method: HttpMethod.GET,
        headers,
      });

      if (response.isEmpty()) {
        return [];
      }

      return response.data.filter((subdomain) => subdomain.enabled === true) ?? [];
    },
    enabled: !!buildingUuid && !!apiUrl,
  });
};
